import './utils/utcDates';   // first: makes stored UTC timestamps display in the viewer's own (India) time
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Installable "Salvador CRM" phone app — only on the CRM host (crm.* /
// localhost), never on the customer storefront (www), which shares this
// same build. Adds the web-app manifest + iPhone home-screen tags, registers
// the (non-caching) service worker, and keeps Chrome's install prompt so the
// phone Home screen can offer an "Install" button (mobile/MobileHome.js).
{
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1' || h.startsWith('crm.')) {
    const add = (tag, attrs) => { const el = document.createElement(tag); Object.assign(el, attrs); document.head.appendChild(el); };
    add('link', { rel: 'manifest', href: '/crm-manifest.json' });
    add('link', { rel: 'apple-touch-icon', href: '/crm-apple-touch-icon.png' });
    add('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' });
    add('meta', { name: 'apple-mobile-web-app-title', content: 'Salvador CRM' });
    add('meta', { name: 'apple-mobile-web-app-status-bar-style', content: 'default' });
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => navigator.serviceWorker.register('/crm-sw.js').catch(() => {}));
    }
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      window.__crmInstallPrompt = e;
      window.dispatchEvent(new Event('crm-install-ready'));
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
